import React from 'react';
import { formaDespacho as listaDespacho } from '../../../data/listasDesplegables';

/**
 * SectionDespachoArt - Componente modular para la carga de datos de despacho y seguimiento.
 * Adaptado con foco estilizado y transiciones armonizadas con el diseño global.
 */
const SectionDespachoArt = ({ state, actions }) => {
    const { formData } = state;
    const { handleChange } = actions;

    return (
        <fieldset className="border border-slate-200 rounded-xl p-6 bg-white shadow-sm text-left animate-fade-in transition-all duration-300">
            <legend className="px-3 text-base font-bold text-slate-700 tracking-tight">Despacho y Seguimiento</legend>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pt-2">
                
                {/* 1. FECHA DESPACHO */}
                {}
                <div>
                    <label className="label-form text-slate-600 font-bold mb-1 block">Fecha de Despacho</label>
                    <input 
                        type="date" 
                        name="fechaDespacho" 
                        value={formData.fechaDespacho || ''} 
                        onChange={handleChange} 
                        className="input-round border-slate-200 w-full rounded-xl px-4 py-2.5 h-[46px] outline-none border transition-all focus:border-indigo-500 focus:ring-1 focus:ring-indigo-100" 
                    />
                </div>

                {/* 2. FORMA DESPACHO */}
                {}
                <div>
                    <label className="label-form text-slate-600 font-bold mb-1 block">Forma de Despacho</label>
                    <select 
                        name="formaDespacho" 
                        value={formData.formaDespacho || ''} 
                        onChange={handleChange} 
                        className="input-round border-slate-200 font-bold text-slate-700 w-full rounded-xl px-4 py-2.5 h-[46px] outline-none border transition-all focus:border-indigo-500 focus:ring-1 focus:ring-indigo-100"
                    >
                        <option value="">Seleccione...</option>
                        {listaDespacho.map(f => (
                            <option key={f} value={f}>{f}</option>
                        ))}
                    </select>
                </div>
            </div>
        </fieldset>
    );
};

export default SectionDespachoArt;